import { render, staticRenderFns } from "./foodPackAdd.vue?vue&type=template&id=4d940a2d&scoped=true&"
import script from "./foodPackAdd.vue?vue&type=script&lang=js&"
export * from "./foodPackAdd.vue?vue&type=script&lang=js&"
import style0 from "./foodPackAdd.vue?vue&type=style&index=0&id=4d940a2d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d940a2d",
  null
  
)

export default component.exports